import PropTypes from "prop-types";
import {debounce} from "../../util/util";

const CustomInput = ({label, id, name, className, type, placeholder, inputHandler, pattern, maxLength}) => {

    const debounceHandler = debounce(inputHandler, 500);

    return (
        <>
            <input
                className={className}
                type={type}
                name={name}
                id={id}
                placeholder={placeholder}
                maxLength={maxLength}
                onInput={(event) => {
                    debounceHandler(event.target.value);
                pattern={pattern};
            }}/>
            <label htmlFor="floatingInput">{label}</label>
        </>
    );
}

CustomInput.propTypes = {
    label: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    className: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    inputHandler: PropTypes.func.isRequired,
    pattern: PropTypes.string.isRequired,
    maxLength: PropTypes.number,
};

CustomInput.defaultProps = {
    label: "",
    id: "floatingInput",
    name: "",
    className: "form-floating mb-3",
    type: "text",
    placeholder: "",
    inputHandler: () => {},
    pattern: ".*",
    maxLength: 100,
};

export default CustomInput;